import type { RankJobOption } from '@/domain/types'
import { jobIdentities, normalizeJobText, resolveJobIdentity } from './job-name'

export const rankJobOptions: readonly RankJobOption[] = jobIdentities.map(({ jobKey, rankName }) => ({ jobKey, jobName: rankName }))

export const normalizeRankJobName = normalizeJobText

export function matchRankJob(value: string | null | undefined): RankJobOption | null {
  const job = resolveJobIdentity(value)
  return job ? { jobKey: job.jobKey, jobName: job.rankName } : null
}
